import { map as _map } from 'lodash';

export default class LookupService {
  constructor($http, $q, appConfig, storageProvider = window.sessionStorage) {
    "ngInject";

    this.$http = $http;
    this.$q = $q;
    this.appConfig = appConfig;
    this.storageProvider = storageProvider;
  }

  lookup(lookupName, params) {
    const deferred = this.$q.defer();
    let lookupData = JSON.parse(this.storageProvider.getItem(`lookups.${lookupName}`));
    let query = this.appConfig.apiServiceBaseUri + `api/lookup/${lookupName}?`;

    if (!lookupData || !lookupData.length)
    {
      if (params) {
        _map(params, (itemValue, itemName) => {
          query += `${itemName}=${itemValue}&`;
        })
      }

      this.$http.get(query)
        .then(response => {
          if (!params) {
            this.storageProvider.setItem(`lookups.${lookupName}`, JSON.stringify(response.data.items))
          }

          deferred.resolve(response.data.items || response.data);
        })
        .catch(err => {
          deferred.reject(err);
        })
    } else {
      deferred.resolve(lookupData);
    }
    return deferred.promise;
  }

  lookupEnums(enumNames) {
    const deferred = this.$q.defer();
    let enumsToLookupFromServer = [];
    let enumLookupCollection = {};

    enumNames.map(enumName => {
      const lookupData = JSON.parse(this.storageProvider.getItem(`lookups.${enumName.toCamelCase()}`));

      if (!lookupData || !lookupData.length) {
        enumsToLookupFromServer.push(enumName);
      }
      else {
        enumLookupCollection[enumName.toCamelCase()] = lookupData;
      }
    });

    if (enumsToLookupFromServer.length) {
      this.$http.get(this.appConfig.apiServiceBaseUri + `api/lookup/enums?enumNames=${enumsToLookupFromServer.toString()}`)
        .then(response => {
          response.data.map(enumLookup => {
            enumLookupCollection[enumLookup.enumName.toCamelCase()] = enumLookup.values;
            this.storageProvider.setItem(`lookups.${enumLookup.enumName.toCamelCase()}`, JSON.stringify(enumLookup.values))
          });
          deferred.resolve(enumLookupCollection);
        })
        .catch(err => {
          deferred.reject(err);
        })
    }
    else {
      deferred.resolve(enumLookupCollection);
    }

    return deferred.promise;
  }

  lookupRoles() {
    const deferred = this.$q.defer();

    var roles = [
      {"roleId":1,"name":"Administrator"},
      {"roleId":2,"name":"Sales Manager"},
      {"roleId":3,"name":"Sales Rep"},
      {"roleId":4,"name":"Showroom Host"},
      {"roleId":5,"name":"Accounts Admin"}
    ];
    
    deferred.resolve(roles);

    return deferred.promise;
  }

  lookupBrands() {
    return this.lookup('brands');
  }

  lookupBrandModels() {
    return this.lookup('brandModels');
  }

  lookupPriceLookups(entityId) {
    return this.lookup('priceLookups', {
      entityId: entityId
    });
  }

  lookupAccessoryLookups(entityId, locationOnly) {
    return this.lookup('accessoryLookups', {
      entityId: entityId,
      locationOnly: locationOnly ? true : false
    });
  }

  lookupEnquiryPrices(entityId) {
    return this.lookup('enquiryPrices', {
      entityId: entityId
    });
  }

  lookupEntityNamesByIds(entityIds) {
    return this.lookup('entityNameLookup', {
      entityIds: entityIds
    });
  }

  lookupVehicleByRegNo(locationId, vehicleCondition, regNo, validate) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/lookup/vehicle/${locationId}/${vehicleCondition}/${regNo}/${validate}`);
  }

  lookupMyLocations(locationId) {
    return this.$http.get(this.appConfig.apiServiceBaseUri + `api/lookup/mylocations/${locationId}`);
  }  
}



// WEBPACK FOOTER //
// ./client/app/common/services/lookupService.js